import { palette, TPalette } from '@shared/tokens/palette.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  name: {
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.primaryText,
    maxWidth: '50rem',
    overflow: 'hidden',
  },
  coloredName: (color: keyof TPalette) => ({
    display: 'block',
    padding: `${anatomy['space-4']} ${anatomy['space-12']}`,
    borderRadius: anatomy.borderRadiusRound,
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: typography['lineHeightCaption-2'],
    color: colors.primaryInverseText,
    background: palette[color],
    maxWidth: '50rem',
    overflow: 'hidden',
  }),
});
